import { render, staticRenderFns } from "./GeofencesCrossing.vue?vue&type=template&id=d5028edc&scoped=true&lang=pug"
import script from "./GeofencesCrossing.vue?vue&type=script&lang=js"
export * from "./GeofencesCrossing.vue?vue&type=script&lang=js"
import style0 from "./GeofencesCrossing.vue?vue&type=style&index=0&id=d5028edc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5028edc",
  null
  
)

export default component.exports